module.exports = __webpack_public_path__ + "img/btn-border-black-sloped.7f643346.svg";